import { render, staticRenderFns } from "./item-quantities-info.vue?vue&type=template&id=647feaaf&scoped=true&"
import script from "./item-quantities-info.vue?vue&type=script&lang=js&"
export * from "./item-quantities-info.vue?vue&type=script&lang=js&"
import style0 from "./item-quantities-info.vue?vue&type=style&index=0&id=647feaaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647feaaf",
  null
  
)

export default component.exports